import React from "react";
import Nav from "../components/Nav";
import Circles from "../components/Circles";

function Conditions({noNav}) {
  return (
    <section className="bg-petrol-500">
      {!noNav && <Nav />}
      <div className="container text">
        <h1 className="mb-8 self-center">Tävlingsvillkor</h1>
        <ol type="1" className="list-decimal">
          <li className="mb-4 px-2">
            Genom att acceptera tävlingsvillkoren godkänner du att de uppgifter
            du lämnar om dig själv i samband med insändande av bidrag kommer att
            behandlas för att kunna administrera tävlingen samt för
            kommunikation med dig under Quiz-kampanjens period. I samband med
            publicering av vinnare av tävlingen kommer personuppgifter som namn
            att publiceras på Frölunda Torgs sociala kanaler och hemsida samt på
            quizets topplista. Efter avslutad tävling, och när priserna har
            delats ut till vinnarna, kommer personuppgifter som samlats in om de
            tävlande att raderas.
          </li>
          <li className="mb-4 px-2">
            Genom att godkänna dessa allmänna tävlingsvillkor samtycker du till
            personuppgiftsbehandling enligt ovan.
          </li>
          <li className="mb-4 px-2">
            Ansvarig för tävlingen är Frölunda Torgs Centrumledning via Skandia
            Fastigheter.
          </li>
          <li className="mb-4 px-2">
            För att delta i finaltävlingen måste du bo och vara folkbokförd i
            Sverige, ha fyllt 16 år vid tävlingens start samt acceptera reglerna
            för tävlingen. Om du inte har fyllt 18 år än måste du ha målsmans
            godkännande för deltagande i finalevent.
          </li>
          <li className="mb-4 px-2">
            För att delta i tävlingen skickar du in dina svarsresultat i quizet
            tillsammans med ditt namn, mobilnummer och e-postadress.
            Tävlingsbidrag utan kontaktuppgifter blir diskvalificerade. Dina
            kontaktuppgifter kommer inte att publiceras utan kommer endast
            användas för att komma i kontakt med dig om du får möjlighet att
            delta i finalen eller har blivit en veckovinnare.
          </li>
          <li className="mb-4 px-2">
            Om Frölunda Torg har anledning att tro att du använt falska
            uppgifter eller om du angivit ett påhittat namn till topplistan
            förbehåller sig Frölunda Torg att diskvalificera ditt inskick och ta
            bort dig från topplistan.
          </li>
          <li className="mb-4 px-2">
            Möjlighet att bli utvald till finaleventet är under perioden 18
            mars–21 april. Den digitala tävlingen avslutas den 22 april då
            finalisterna börjar bli kontaktade. Finaleventet sker den 27 april.
            Totalt finns det en vinstpott på 40 000 kr i presentkort på Frölunda
            Torg, fördelad enligt följande: 30 000 kr till vinnaren, 3000 kr
            till andrapristagaren och 2000 kr till tredjepristagaren på
            finaleventet. Samt 5 st veckovinnare i den digitala tävlingen med
            vinster på 1000 kr/st, dvs. totalt 5000 kr. Vinnarna hämtar ut sina
            presentkort personligen i infodisken på Frölunda Torg.
            Legitimation/ID-handling krävs. Alla presentkort har en
            giltighetstid på 2 år från datumet som pengarna laddats på kortet.
          </li>
          <li className="mb-4 px-2">
            Tävlingsfrågorna är baserade på aktuell information, insamlad från
            respektive verksamhet under januari 2024. Alla rätta svar på
            frågorna i quizet kommer att publiceras på Frölunda Torgs hemsida
            efter kampanjperiodens slut. Håll utkik i Frölunda Torgs sociala
            kanaler för information om när svaren publiceras!
          </li>
          <li className="mb-4 px-2">
            Frölunda Torg förbehåller sig rätten att inte utfärda något pris
            (och att välja ut en annan vinnare) om Frölunda Torg får vetskap om,
            eller på sannolika grunder anser att, en vinnare inte är
            kvalificerad att delta i tävlingen.
          </li>
          <li className="mb-4 px-2">
            Frölunda Torg tar inte ansvar för borttappat eller på annat sätt
            förlorat presentkort. Efter överlämning av presentkort till
            vinnarna, är presentkortet vinnarens ansvar.
          </li>
          <li className="mb-4 px-2">
            I händelse av dispyt över reglerna, uppträdande, resultat och alla
            andra ärenden i relation till tävlingen kommer Frölunda Torgs beslut
            att vara slutgiltigt och ingen korrespondens eller diskussion kommer
            att inledas.
          </li>
          <li className="mb-4 px-2">
            Vid misstanke om fusk i något avseende äger Frölunda Torg rätt att
            diskvalificera bidrag. Detta liksom övriga beslut av tävlingsjuryn
            kan inte överklagas.
          </li>
          <li className="mb-4 px-2">
            Vinnarna utses av en jury bestående av representanter från Frölunda
            Torgs Centrumledning via Skandia Fastigheter. Juryns beslut kan inte
            överklagas och juryn behöver inte motivera sitt beslut. Vinnare är
            dem som svarat rätt på flest frågor på snabbast tid. Det finns inte
            möjlighet att vinna mer än en veckovinst. En veckovinst påverkar
            inte din möjlighet att komma till finaleventet.
          </li>
          <li className="mb-4 px-2">
            Vinnarna kommer att kontaktas via e-post och/eller telefon. Frölunda
            Torg kommer att försöka nå vinnaren under 24 timmar från att varje
            veckotävling avslutats samt finalisterna under 22–24 april. Om vi ej
            kommer i kontakt med dig förbehåller sig Frölunda Torg att kontakta
            nästa person i topplistan för möjlighet att delta i finaleventet.
          </li>
          <li className="mb-4 px-2">
            Det är inte möjligt att byta ut vinsten mot kontanter eller mot
            andra varor.
          </li>
          <li className="mb-4 px-2">
            Genom att delta i tävlingen garanterar du att du uppfyller
            tävlingsvillkoren. Frölunda Torg förbehåller sig rätten att
            diskvalificera bidrag som inte uppfyller ovan tävlingsvillkor.
          </li>
          <li className="mb-4 px-2">
            Anställda eller närstående till anställda på Frölunda Torg eller hos
            Frölunda Torgs samarbetspartners får inte delta i tävlingen.
          </li>
        </ol>
      </div>
    </section>
  );
}

export default Conditions;
